import { motion } from "framer-motion";
import { Check, X } from "lucide-react";
import { useContent } from "../context/ContentContext";

export const Comparison = () => {
  const { content } = useContent();
  const c = content.comparison || {};
  const competitors = c.competitors || [];
  const rows = c.rows || [];

  return (
    <section id="compare" className="relative py-24 lg:py-36 max-w-[1400px] mx-auto px-6 lg:px-10">
      <div className="mb-14 max-w-2xl">
        <span className="font-mono text-xs uppercase tracking-[0.3em] text-accent">// The Math</span>
        <h2 className="mt-5 font-display font-black uppercase tracking-tighter text-4xl sm:text-6xl leading-[0.9]">{c.heading}</h2>
        <p className="mt-6 font-body text-white/50 leading-relaxed">{c.sub}</p>
      </div>

      {/* Price cards */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-px bg-white/10 border border-white/10 mb-px">
        <motion.div
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          className="col-span-2 md:col-span-1 bg-accent p-6 flex flex-col justify-between min-h-[140px]"
        >
          <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/90">{c.ourName}</span>
          <div>
            <div className="font-display font-black text-4xl text-white leading-none">{c.ourPrice}</div>
            <div className="font-mono text-[10px] uppercase tracking-[0.15em] text-white/80 mt-1">{c.ourCadence}</div>
          </div>
        </motion.div>
        {competitors.map((comp, i) => (
          <motion.div
            key={comp.name}
            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ delay: i * 0.05 }}
            className="bg-[#0a0a0a] p-6 flex flex-col justify-between min-h-[140px]"
          >
            <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/50">{comp.name}</span>
            <div>
              <div className="font-display font-black text-3xl text-white/70 leading-none">{comp.price}</div>
              <div className="font-mono text-[10px] uppercase tracking-[0.15em] text-white/35 mt-1">{comp.cadence}</div>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Feature rows */}
      <div className="border border-t-0 border-white/10">
        {rows.map((row, i) => (
          <motion.div
            key={i}
            data-testid={`compare-row-${i}`}
            initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
            transition={{ delay: i * 0.04 }}
            className="grid grid-cols-[1fr_auto_auto] items-center gap-4 px-5 lg:px-7 py-4 border-b border-white/10 last:border-b-0 bg-[#050505] hover:bg-[#0d0d0d] transition-colors"
          >
            <span className="font-body text-sm text-white/75">{row}</span>
            <span className="flex items-center gap-2 justify-end min-w-[90px]">
              <span className="h-6 w-6 flex items-center justify-center bg-accent"><Check size={14} className="text-white" strokeWidth={3} /></span>
              <span className="font-mono text-[9px] uppercase tracking-[0.15em] text-accent hidden sm:inline">Us</span>
            </span>
            <span className="flex items-center gap-2 justify-end min-w-[90px]">
              <span className="h-6 w-6 flex items-center justify-center border border-white/15"><X size={14} className="text-white/30" strokeWidth={2.5} /></span>
              <span className="font-mono text-[9px] uppercase tracking-[0.15em] text-white/30 hidden sm:inline">Them</span>
            </span>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
